<template>
  <div style="display:none" class="modal fade" :id="id">
    <div class="modal-dialog">
      <div class="modal-content" :style="{height: contentHeight + 'px'}">
        <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
          </button>
          <h4 class="modal-title" id="myModalLabel">
            {{title}} {{mMsg}}
          </h4>
        </div>
        <div class="modal-body">
          <slot name="body"></slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import logger from '../../lib/utils/logger.js'
  import mixins from '../../mixins/index'
  import commonMethods from '../../lib/methods/common.js'

  export default {
    name: 'bootstrap-modal',
    mixins: mixins,
    props: {
      contentHeight: String,
      title: String,
      id: String
    },
    data () {
      return {
        mMsg: '',
        mChild: null
      }
    },
    mounted () {
      window.$(this.$el).on('hide.bs.modal', (e) => {
        this.$emit('hide-bs-modal', e)
      }).on('hidden.bs.modal', (e) => {
        this.$emit('hidden-bs-modal', e)
      }).on('show.bs.modal', (e) => {
        this.$emit('show-bs-modal', e)
      }).on('shown.bs.modal', (e) => {
        this.$emit('shown-bs-modal', e)
      })
    },
    methods: {
      show (args) {
        for (let i in this.$children) {
          logger.info('In modal, child: [' + this.$children[i].$options.name + '], options: ' + this.strify(args))
          if (typeof this.$children[i].onShowInModal === 'function') {
            this.$children[i].onShowInModal(args)
          }
        }
        window.$(this.$el).modal({keyboard: true, backdrop: 'static'})
        return this
      },
      hide (args) {
        for (let i in this.$children) {
          if (typeof this.$children[i].onHideInModal === 'function') {
            this.$children[i].onHideInModal(args)
          }
        }
        window.$(this.$el).modal('hide')
        return this
      },
      msg (arg1) {
        this.mMsg = arg1
        return this
      },
      child (arg1) {
        if (arg1 && typeof arg1 === 'object') {
          this.mChild = arg1
        } else {
          return this.mChild
        }
      },
      ...commonMethods
    }
  }
</script>
<style scoped>
.modal-content {
  width: 700px;
}
</style>



// WEBPACK FOOTER //
// BootstrapModal.vue?43f227ca